import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { Checkbox } from "../ui/checkbox";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { CaretDown } from "@phosphor-icons/react";

export const StandardMultiSelect = ({ standards, value, onToggle }) => {
  const [q, setQ] = useState("");
  const term = q.trim().toLowerCase();
  const list = standards.filter((s) => !term || `${s.standard_id} ${s.title}`.toLowerCase().includes(term));
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button data-testid="sop-multi-standard-trigger" variant="outline" className="rounded-none w-full justify-between font-normal mt-1">
          <span className="truncate">{value.length ? value.join(", ") : "Select standards…"}</span>
          <CaretDown size={14} className="shrink-0 ml-2" />
        </Button>
      </PopoverTrigger>
      <PopoverContent align="start" className="rounded-none p-0 w-[360px]">
        <div className="p-2 border-b border-border">
          <Input data-testid="sop-multi-standard-search" autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search e.g. TOP-001, CIP-007…" className="rounded-none h-8 text-sm" />
        </div>
        <div className="max-h-72 overflow-y-auto py-1">
          {list.map((s) => (
            <label key={s.standard_id} data-testid={`sop-multi-standard-opt-${s.standard_id}`}
              className="flex items-start gap-2 px-3 py-1.5 text-sm cursor-pointer hover:bg-secondary/60">
              <Checkbox checked={value.includes(s.standard_id)} onCheckedChange={() => onToggle(s.standard_id)} className="mt-0.5 rounded-none" />
              <span className="flex-1">
                <span className="font-mono font-semibold">{s.standard_id}</span> <span className="text-muted-foreground">— {s.title}</span>
                {s.status && s.status !== "currently_enforceable" && (
                  <span className="ml-1 text-[10px] uppercase border border-amber-400 text-amber-700 px-1">{s.status.replace(/_/g, " ")}</span>
                )}
              </span>
            </label>
          ))}
          {!list.length && <div className="px-3 py-4 text-xs text-muted-foreground">No standards match.</div>}
        </div>
      </PopoverContent>
    </Popover>
  );
};
